import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from '../api/axios';
import AuthContext from '../context/AuthContext';
import SkeletonLoader from './SkeletonLoader';
// Aggiunte icone
import { FaEdit, FaTrash, FaEnvelope, FaUserTag, FaBuilding } from 'react-icons/fa';

const UsersLocalModule = () => {
    const { auth } = useContext(AuthContext);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    
    const [showModal, setShowModal] = useState(false);
    const [actionUser, setActionUser] = useState(null);
    const [formData, setFormData] = useState({ id: null, name: '', email: '', user_role: 'user', is_active: 1 });
    const [message, setMessage] = useState({ text: '', type: '' });

    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            const tenantId = auth.tenant_id;
            const url = `/api_users.php?role=${auth.role}&tenant_id=${tenantId}&search=${searchTerm}`;
            const response = await axios.get(url);
            if (response.data.success) {
                setUsers(response.data.data);
            }
        } catch (error) { console.error(error); } 
        finally { setLoading(false); }
    }, [auth, searchTerm]);

    useEffect(() => {
        const timer = setTimeout(() => fetchUsers(), 500);
        return () => clearTimeout(timer);
    }, [fetchUsers]);

    const openModal = (user = null) => {
        setActionUser(null);
        setMessage({ text: '', type: '' });
        if (user) {
            setFormData({ id: user.id, name: user.name, email: user.email, user_role: user.role, is_active: user.is_active });
        } else {
            setFormData({ id: null, name: '', email: '', user_role: 'user', is_active: 1 });
        }
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ text: 'Salvataggio...', type: 'info' });
        try {
            const method = formData.id ? 'put' : 'post';
            const payload = { ...formData, role: auth.role, tenant_id: auth.tenant_id };
            const response = await axios[method]('/api_users.php', JSON.stringify(payload));
            if (response.data.success) {
                setMessage({ text: response.data.message, type: 'success' });
                fetchUsers();
                setTimeout(() => setShowModal(false), 1500);
            } else {
                setMessage({ text: response.data.message, type: 'danger' });
            }
        } catch (error) { setMessage({ text: 'Errore.', type: 'danger' }); }
    };

    const handleDelete = async (id) => {
        setActionUser(null);
        if (!window.confirm("Eliminare utente?")) return;
        try {
            await axios.delete(`/api_users.php?id=${id}&role=${auth.role}&tenant_id=${auth.tenant_id}`);
            fetchUsers();
        } catch (error) { alert("Errore"); }
    };

    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-primary fw-bold m-0">Utenti Tenant</h4>
                <button className="btn btn-success btn-sm shadow-sm" onClick={() => openModal()}>
                    + Invita
                </button>
            </div>

            <div className="card shadow-sm mb-3 border-0">
                <div className="card-body p-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Cerca..." 
                        value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                </div>
            </div>

            {/* --- DESKTOP VIEW --- */}
            <div className="card shadow-sm border-0 d-none d-md-block">
                <div className="card-body p-0">
                    <table className="table table-hover align-middle mb-0" style={{fontSize: '0.9rem'}}>
                        <thead className="bg-light">
                            <tr>
                                <th className="ps-4">Nome</th>
                                <th>Email</th>
                                <th>Ruolo</th>
                                <th>Stato</th>
                                <th className="text-end pe-4">Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                [...Array(3)].map((_, i) => <tr key={i}><td colSpan="5" className="p-3"><SkeletonLoader /></td></tr>)
                            ) : users.map(user => (
                                <tr key={user.id}>
                                    <td className="ps-4 fw-bold">{user.name}</td>
                                    <td>{user.email}</td>
                                    <td><span className={`badge ${user.role === 'admin' ? 'bg-warning text-dark' : 'bg-info'}`}>{user.role}</span></td>
                                    <td>{user.is_active ? <span className="badge bg-success">Attivo</span> : <span className="badge bg-danger">Sospeso</span>}</td>
                                    <td className="text-end pe-4">
                                        <button className="btn btn-sm btn-outline-primary me-2" onClick={() => openModal(user)}>Modifica</button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(user.id)}>Elimina</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* --- MOBILE VIEW (AGGIORNATA) --- */}
            <div className="d-md-none">
                {loading ? (
                    [...Array(3)].map((_, i) => <div key={i} className="mb-2"><SkeletonLoader height="80px"/></div>)
                ) : users.length > 0 ? (
                    users.map(user => (
                        <div 
                            key={user.id} 
                            className="card mb-2 shadow-sm border-0"
                            onClick={() => setActionUser(user)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="card-body p-3">
                                {/* Riga 1: Nome + Pallino */}
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-bold text-dark text-truncate pe-2">{user.name}</span>
                                    <div 
                                        className={`rounded-circle ${user.is_active ? 'bg-success' : 'bg-danger'}`} 
                                        style={{ width: '10px', height: '10px', flexShrink: 0 }}
                                    ></div>
                                </div>
                                
                                {/* Riga 2: Email */}
                                <div className="d-flex align-items-center text-muted small mb-2">
                                    <FaEnvelope className="me-2 text-primary opacity-75" />
                                    <span className="text-truncate">{user.email}</span>
                                </div>

                                {/* Riga 3: Ruolo e Tenant */}
                                <div className="d-flex align-items-center text-muted small">
                                    <div className="d-flex align-items-center me-3" style={{minWidth: '80px'}}>
                                        <FaUserTag className="me-2 text-warning opacity-75" />
                                        <span className="text-uppercase" style={{fontSize: '0.75rem'}}>{user.role}</span>
                                    </div>
                                    <div className="d-flex align-items-center text-truncate">
                                        <FaBuilding className="me-2 text-secondary opacity-75" />
                                        <span className="text-truncate" style={{maxWidth: '120px'}}>{user.tenant_name || auth.tenant_name || 'My Tenant'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center text-muted py-5">Nessun utente.</div>
                )}
            </div>

            {/* --- ACTION MENU MOBILE --- */}
            {actionUser && (
                <div className="modal d-block" style={{backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060}} onClick={() => setActionUser(null)}>
                    <div className="modal-dialog modal-dialog-centered px-4">
                        <div className="modal-content shadow border-0" onClick={e => e.stopPropagation()}>
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fw-bold text-truncate">{actionUser.name}</h5>
                                <button className="btn-close" onClick={() => setActionUser(null)}></button>
                            </div>
                            <div className="modal-body">
                                <p className="text-muted small mb-3">Opzioni Utente</p>
                                <div className="d-grid gap-2">
                                    <button className="btn btn-outline-primary py-2 d-flex align-items-center justify-content-center" onClick={() => openModal(actionUser)}>
                                        <FaEdit className="me-2" /> Modifica
                                    </button>
                                    <button className="btn btn-outline-danger py-2 d-flex align-items-center justify-content-center" onClick={() => handleDelete(actionUser.id)}>
                                        <FaTrash className="me-2" /> Elimina
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* --- MODALE FORM (Invariata) --- */}
            {showModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">{formData.id ? 'Modifica' : 'Invita'} Utente</h5>
                                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                {message.text && <div className={`alert alert-${message.type}`}>{message.text}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label>Nome Completo</label>
                                        <input type="text" className="form-control" required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} />
                                    </div>
                                    <div className="mb-3">
                                        <label>Email</label>
                                        <input type="email" className="form-control" required disabled={!!formData.id} value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
                                    </div>
                                    <div className="row">
                                        <div className="col-6 mb-3">
                                            <label>Ruolo</label>
                                            <select className="form-select" value={formData.user_role} onChange={e => setFormData({...formData, user_role: e.target.value})}>
                                                <option value="user">Studente</option>
                                                <option value="admin">Istruttore</option>
                                            </select>
                                        </div>
                                        {formData.id && (
                                            <div className="col-6 mb-3">
                                                <label>Stato</label>
                                                <select className="form-select" value={formData.is_active} onChange={e => setFormData({...formData, is_active: parseInt(e.target.value)})}>
                                                    <option value={1}>Attivo</option>
                                                    <option value={0}>Sospeso</option>
                                                </select>
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-end mt-2">
                                        <button type="button" className="btn btn-secondary me-2" onClick={() => setShowModal(false)}>Annulla</button>
                                        <button type="submit" className="btn btn-primary">Salva</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UsersLocalModule;